<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：权限-管理员列表-添加管理员
    -->
  <el-dialog title="上传电子票据" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">

    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :label-width="formLabelWidth">
      <el-form-item label="票据：" prop="receipt"  :label-width="formLabelWidth">
        <div class="draggable-list">
            <div v-if="form.receipt">
                <div class="item">
                  <img v-img-url="form.receipt" alt="file_path"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg('receipt')"><i class="el-icon-close"></i></a>
                  </div>
              </div>
          <div class="item img-select" @click="openReceiptUpload('receipt')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
    <Upload v-if="isPeceiptUpload" :config="{ total: 1 }" :isupload="isPeceiptUpload" @returnImgs="returnPeceiptImgsFunc">上传图片
    </Upload>
  </el-dialog>
</template>

<script>
import StoreApi from '@/api/store.js';
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
},
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
      isPeceiptUpload:false,
      rolearr:[],
      form: {
        receipt: '' // 用于存储票据图片路径
      },
      pay_order_id:0
    };
  },
  props: ['open',"pay_order_id"],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
      }
    }
  },
  created() {
    
  },
  methods: {
    deleteImg(field) {
      // 清空对应字段的值
        this.form[field] = '';
    },
    /*打开上传图片*/
    openReceiptUpload: function (code) {
      this.isPeceiptUpload = true;
      this.code = code
    },

    /*上传商品图片*/
   returnPeceiptImgsFunc(e) {
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

          var receipt = e[0].file_path;
          this.form.receipt = receipt;
          this.$set(this.form, "receipt", receipt);
      }
   
      
      this.isPeceiptUpload = false;
    },

    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      self.form.pay_order_id = self.pay_order_id;
      let params = self.form;
      self.$refs.form.validate((valid) => {
        if(valid){
            StoreApi.uploadReceipt(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '添加成功',
              type: 'success'
            });
            this.form.nickName=''
            this.form.mobile=''
            this.form.grade_id=''
            self.dialogFormVisible(true);
          })
          .catch(error => {
            self.loading = false;
          });
        }if(!valid){
          self.loading = false;
        }

      });


    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/store/order/upload.vue